/**
 * @generated SignedSource<<d30e2a8833265948b2da62bea9f44148>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment$data = {
  readonly dailyDueDateNotification: {
    readonly id: string;
    readonly inProductChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment";
};
export type combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment$key = {
  readonly " $data"?: combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "dailyDueDateNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "dailyDueDateNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "inProductChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "ff67dbedfb6689d832f3f9ea10816115";

export default node;
